import React, { useRef, useEffect, useContext } from "react";
import Slider from "react-slick";
import { MdArrowOutward, MdPlace } from "react-icons/md";
import { AppContext } from "../App";
import { company, heroSlides } from "../siteContent";
import bgVideo from "../assets/bg_video.mp4";

export default function HomeSlider() {
  const sliderRef = useRef(null);
  const appContext = useContext(AppContext);

  useEffect(() => {
    const slider = sliderRef.current;

    const preventTouchEvents = (e) => {
      e.stopPropagation();
    };

    if (slider) {
      slider.addEventListener("touchstart", preventTouchEvents);
      slider.addEventListener("touchmove", preventTouchEvents);
      slider.addEventListener("touchend", preventTouchEvents);
    }

    return () => {
      if (slider) {
        slider.removeEventListener("touchstart", preventTouchEvents);
        slider.removeEventListener("touchmove", preventTouchEvents);
        slider.removeEventListener("touchend", preventTouchEvents);
      }
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5200,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
  };

  return (
    <div className="WelcomeSlider tff-hero" ref={sliderRef}>
      <div className="tff-hero-media" aria-hidden="true">
        <video className="tff-hero-video" autoPlay muted loop playsInline>
          <source src={bgVideo} type="video/mp4" />
        </video>
      </div>

      <div className="tff-hero-slider-layer ">
        <Slider {...settings}>
          {heroSlides.map((item, index) => (
            <div key={index} style={{ width: "100%", height: "auto", overflow: "hidden" }}>
              <div className="tff-tour-hero">
                <div className="tff-hero-overlay">
                  <div className="container">
                    <div className="row align-items-center min-vh-100">
                      <div className="col-lg-7">
                        <div className="tff-tour-hero-copy text-light">
                          <div className="tff-hero-badge">
                            <MdPlace size={18} />
                            <span className="font-semi-bold">{item.kicker}</span>
                          </div>

                          <h1 className="font-light text-light tff-tour-hero-title">{item.title}</h1>
                          <p className="font-light text-light tff-tour-hero-text">{item.description}</p>

                          <div className="d-flex flex-wrap gap-3 mt-4">
                            <button
                              className="btn btn-secondary btn-rounded btn-padded"
                              onClick={() => {
                                appContext.navTo({ item: item.primaryItem });
                              }}
                            >
                              {item.primaryAction}
                            </button>
                            <button
                              className="btn btn-outline-light btn-rounded btn-padded"
                              onClick={() => {
                                appContext.navTo({ item: item.secondaryItem });
                              }}
                            >
                              {item.secondaryAction}
                            </button>
                          </div>

                          <div className="tff-tour-hero-footer">
                            <div className="tff-tour-stat-card">
                              <p className="font-semi-bold mNoMargin">Base</p>
                              <span className="font-light">{company.location}</span>
                            </div>
                            <div className="tff-tour-stat-card">
                              <p className="font-semi-bold mNoMargin">Travel Style</p>
                              <span className="font-light">Private, group, corporate, and special-interest travel</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5 d-none d-lg-block">
                        <div className="tff-hero-cards">
                          {item.points.map((point, pi) => (
                            <div key={pi} className="tff-hero-mini-card tff-glass">
                              <h6 className="font-semi-bold text-light">{point}</h6>
                              <p className="font-light text-light">Carefully managed by our team.</p>
                            </div>
                          ))}
                        </div>

                        <div className="tff-tour-side-panel">
                          <p className="font-semi-bold text-secondary mb-2">Why travelers choose us</p>
                          <h5 className="font-bold text-light mb-3">A one-stop travel partner for island and mainland experiences.</h5>
                          <button
                            className="btn btn-light btn-rounded btn-padded"
                            onClick={() => {
                              appContext.navTo({ item: "about_us" });
                            }}
                          >
                            Learn More
                            <MdArrowOutward size={18} className="ms-2" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
